export default __webpack_public_path__ + "media/images/plans/boy-8fa12c824591ff4845abce8d8d851e7b.png";